

// import React, { useState } from 'react';
// import { 
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Divider,
//   Switch,
//   FormControlLabel,
//   TextField,
//   InputAdornment,
//   Chip,
//   Tooltip,
//   IconButton,
//   Alert,
//   AlertTitle,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle
// } from '@mui/material';
// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import MDTypography from "components/MDTypography";
// import { 
//   AccessTime, 
//   Security, 
//   ContentCopy, 
//   CheckCircle, 
//   Warning, 
//   HelpOutline,
//   VerifiedUser,
//   History
// } from '@mui/icons-material';
// import { useAuth } from 'auth/Auth';

// const SupportSettings = () => {
//   const { axiosInstance } = useAuth();
//   const [isAccessGranted, setIsAccessGranted] = useState(false);
//   const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
//   const [supportAccessDetails, setSupportAccessDetails] = useState(null);
//   const [accessDuration, setAccessDuration] = useState(24);
//   const [copied, setCopied] = useState(false);
//   const [accessHistory, setAccessHistory] = useState([
//     { grantedAt: '2023-10-15T14:30:00Z', revokedAt: '2023-10-16T14:30:00Z', grantedBy: 'John Doe' },
//     { grantedAt: '2023-09-22T09:15:00Z', revokedAt: '2023-09-23T09:15:00Z', grantedBy: 'John Doe' }
//   ]);
//   const [showHistory, setShowHistory] = useState(false);

//   const handleGrantAccess = async () => {
//     try {
//       // Simulated API call to grant support access
//       const response = await mockGrantSupportAccess(accessDuration);
      
//       setIsAccessGranted(true);
//       setSupportAccessDetails(response);
//       setIsConfirmationModalOpen(false);
//     } catch (error) {
//       console.error('Error granting support access:', error);
//     }
//   };

//   const handleRevokeAccess = async () => {
//     try {
//       // Simulated API call to revoke support access
//       await mockRevokeSupportAccess();
      
//       setIsAccessGranted(false);
//       setSupportAccessDetails(null);
//     } catch (error) {
//       console.error('Error revoking support access:', error);
//     }
//   };

//   const openConfirmationModal = () => {
//     setIsConfirmationModalOpen(true);
//   };

//   const closeConfirmationModal = () => {
//     setIsConfirmationModalOpen(false);
//   };

//   const copyToClipboard = () => {
//     if (supportAccessDetails?.accessToken) {
//       navigator.clipboard.writeText(supportAccessDetails.accessToken);
//       setCopied(true);
//       setTimeout(() => setCopied(false), 2000);
//     }
//   };

//   // Simulated API calls (replace with actual API calls in production)
//   const mockGrantSupportAccess = (hours) => {
//     return new Promise((resolve) => {
//       setTimeout(() => {
//         resolve({
//           accessToken: 'temp_support_access_' + Math.random().toString(36).substr(2, 9),
//           grantedAt: new Date().toISOString(),
//           expiresAt: new Date(Date.now() + hours * 60 * 60 * 1000).toISOString(),
//           duration: hours
//         });
//       }, 500);
//     });
//   };

//   const mockRevokeSupportAccess = () => {
//     return new Promise((resolve) => {
//       setTimeout(() => {
//         resolve(true);
//       }, 500);
//     });
//   };

//   const formatDate = (dateString) => {
//     const options = { 
//       year: 'numeric', 
//       month: 'long', 
//       day: 'numeric', 
//       hour: '2-digit', 
//       minute: '2-digit'
//     };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   const calculateTimeRemaining = (expiryDate) => {
//     const now = new Date();
//     const expiry = new Date(expiryDate);
//     const diffMs = expiry - now;
    
//     if (diffMs <= 0) return 'Expired';
    
//     const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
//     const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    
//     return `${diffHrs}h ${diffMins}m remaining`;
//   };

//   return (
//     <MDBox>
//       <Grid container spacing={3}>
//         <Grid item xs={12} md={7}>
//           <Card sx={{ height: '100%', boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)' }}>
//             <CardContent>
//               <MDTypography variant="h5" fontWeight="medium" mb={2} display="flex" alignItems="center">
//                 <Security sx={{ mr: 1, color: 'info.main' }} />
//                 Support Access Control
//               </MDTypography>
              
//               <Divider sx={{ my: 2 }} />
              
//               {isAccessGranted ? (
//                 <MDBox>
//                   <Alert 
//                     severity="info" 
//                     variant="filled"
//                     sx={{ 
//                       mb: 3, 
//                       alignItems: 'center',
//                       '& .MuiAlert-icon': { fontSize: '2rem' }
//                     }}
//                   >
//                     <AlertTitle sx={{ fontWeight: 'bold' }}>Support Access is Currently Active</AlertTitle>
//                     Support team has temporary access to your account for troubleshooting purposes.
//                   </Alert>
                  
//                   <Grid container spacing={2}>
//                     <Grid item xs={12}>
//                       <MDBox 
//                         bgcolor="grey.100" 
//                         p={2} 
//                         borderRadius="lg"
//                         mb={3}
//                       >
//                         <MDTypography variant="subtitle2" color="text.secondary" gutterBottom>
//                           Access Token
//                         </MDTypography>
//                         <MDBox 
//                           display="flex" 
//                           alignItems="center" 
//                           bgcolor="background.paper"
//                           p={1.5}
//                           borderRadius="md"
//                           border="1px solid"
//                           borderColor="divider"
//                         >
//                           <MDTypography 
//                             variant="body2" 
//                             fontFamily="monospace"
//                             sx={{ 
//                               flexGrow: 1,
//                               overflow: 'hidden',
//                               textOverflow: 'ellipsis'
//                             }}
//                           >
//                             {supportAccessDetails?.accessToken}
//                           </MDTypography>
//                           <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
//                             <IconButton onClick={copyToClipboard} size="small">
//                               {copied ? <CheckCircle color="success" /> : <ContentCopy />}
//                             </IconButton>
//                           </Tooltip>
//                         </MDBox>
//                       </MDBox>
//                     </Grid>
                    
//                     <Grid item xs={12} sm={6}>
//                       <MDBox mb={2}>
//                         <MDTypography variant="subtitle2" color="text.secondary" gutterBottom>
//                           Granted At
//                         </MDTypography>
//                         <MDTypography variant="body2" display="flex" alignItems="center">
//                           <AccessTime sx={{ mr: 1, fontSize: '1rem', color: 'text.secondary' }} />
//                           {formatDate(supportAccessDetails?.grantedAt)}
//                         </MDTypography>
//                       </MDBox>
//                     </Grid>
                    
//                     <Grid item xs={12} sm={6}>
//                       <MDBox mb={2}>
//                         <MDTypography variant="subtitle2" color="text.secondary" gutterBottom>
//                           Expires At
//                         </MDTypography>
//                         <MDBox display="flex" alignItems="center">
//                           <MDTypography variant="body2" mr={1}>
//                             {formatDate(supportAccessDetails?.expiresAt)}
//                           </MDTypography>
//                           <Chip 
//                             size="small" 
//                             label={calculateTimeRemaining(supportAccessDetails?.expiresAt)} 
//                             color="warning"
//                           />
//                         </MDBox>
//                       </MDBox>
//                     </Grid>
//                   </Grid>
                  
//                   <MDBox mt={3} display="flex" justifyContent="center">
//                     <MDButton 
//                       color="error" 
//                       variant="contained"
//                       onClick={handleRevokeAccess}
//                       startIcon={<Warning />}
//                     >
//                       Revoke Access Now
//                     </MDButton>
//                   </MDBox>
//                 </MDBox>
//               ) : (
//                 <MDBox>
//                   <MDTypography variant="body2" color="text.secondary" mb={4}>
//                     Grant temporary access to our support team to help troubleshoot issues with your account.
//                     Support staff will only have access for the specified duration.
//                   </MDTypography>
                  
//                   <MDBox 
//                     bgcolor="grey.100" 
//                     p={3} 
//                     borderRadius="lg"
//                     mb={4}
//                   >
//                     <MDTypography variant="subtitle2" fontWeight="medium" mb={2}>
//                       Access Duration
//                     </MDTypography>
                    
//                     <Grid container spacing={2} alignItems="center">
//                       <Grid item xs={12} sm={8}>
//                         <TextField
//                           fullWidth
//                           type="number"
//                           label="Hours"
//                           value={accessDuration}
//                           onChange={(e) => setAccessDuration(Math.max(1, Math.min(72, parseInt(e.target.value) || 1)))}
//                           InputProps={{
//                             endAdornment: <InputAdornment position="end">hours</InputAdornment>,
//                           }}
//                           helperText="Maximum 72 hours"
//                         />
//                       </Grid>
//                       <Grid item xs={12} sm={4}>
//                         <MDButton 
//                           color="info" 
//                           variant="contained"
//                           fullWidth
//                           onClick={openConfirmationModal}
//                         >
//                           Grant Access
//                         </MDButton>
//                       </Grid>
//                     </Grid>
//                   </MDBox>
                  
//                   <MDBox 
//                     display="flex" 
//                     alignItems="center" 
//                     justifyContent="space-between"
//                     mb={2}
//                   >
//                     <MDTypography variant="subtitle2" fontWeight="medium">
//                       Access History
//                     </MDTypography>
//                     <MDButton 
//                       variant="text" 
//                       color="info" 
//                       size="small"
//                       onClick={() => setShowHistory(!showHistory)}
//                       endIcon={showHistory ? null : <History />}
//                     >
//                       {showHistory ? 'Hide History' : 'View History'}
//                     </MDButton>
//                   </MDBox>
                  
//                   {showHistory && (
//                     <MDBox 
//                       bgcolor="grey.100" 
//                       p={2} 
//                       borderRadius="lg"
//                     >
//                       {accessHistory.length > 0 ? (
//                         accessHistory.map((entry, index) => (
//                           <MDBox 
//                             key={index}
//                             p={1.5}
//                             mb={index < accessHistory.length - 1 ? 1 : 0}
//                             bgcolor="background.paper"
//                             borderRadius="md"
//                             border="1px solid"
//                             borderColor="divider"
//                           >
//                             <Grid container spacing={1}>
//                               <Grid item xs={12} sm={6}>
//                                 <MDTypography variant="caption" color="text.secondary">
//                                   Granted:
//                                 </MDTypography>
//                                 <MDTypography variant="body2">
//                                   {formatDate(entry.grantedAt)}
//                                 </MDTypography>
//                               </Grid>
//                               <Grid item xs={12} sm={6}>
//                                 <MDTypography variant="caption" color="text.secondary">
//                                   Revoked:
//                                 </MDTypography>
//                                 <MDTypography variant="body2">
//                                   {formatDate(entry.revokedAt)}
//                                 </MDTypography>
//                               </Grid>
//                             </Grid>
//                           </MDBox>
//                         ))
//                       ) : (
//                         <MDTypography variant="body2" color="text.secondary" textAlign="center">
//                           No access history available
//                         </MDTypography>
//                       )}
//                     </MDBox>
//                   )}
//                 </MDBox>
//               )}
//             </CardContent>
//           </Card>
//         </Grid>
        
//         <Grid item xs={12} md={5}>
//           <Card sx={{ height: '100%', boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)' }}>
//             <CardContent>
//               <MDTypography variant="h5" fontWeight="medium" mb={2} display="flex" alignItems="center">
//                 <HelpOutline sx={{ mr: 1, color: 'info.main' }} />
//                 About Support Access
//               </MDTypography>
              
//               <Divider sx={{ my: 2 }} />
              
//               <MDBox mb={3}>
//                 <MDTypography variant="subtitle2" fontWeight="medium" gutterBottom>
//                   What is Support Access?
//                 </MDTypography>
//                 <MDTypography variant="body2" color="text.secondary">
//                   Support Access allows our technical team to temporarily access your account to help diagnose and resolve issues you may be experiencing.
//                 </MDTypography>
//               </MDBox>
              
//               <MDBox mb={3}>
//                 <MDTypography variant="subtitle2" fontWeight="medium" gutterBottom>
//                   How it works
//                 </MDTypography>
//                 <MDBox component="ul" pl={2} mb={0}>
//                   <MDTypography component="li" variant="body2" color="text.secondary">
//                     You generate a temporary access token
//                   </MDTypography>
//                   <MDTypography component="li" variant="body2" color="text.secondary">
//                     Share the token with our support team
//                   </MDTypography>
//                   <MDTypography component="li" variant="body2" color="text.secondary">
//                     Support can access your account for the specified duration
//                   </MDTypography>
//                   <MDTypography component="li" variant="body2" color="text.secondary">
//                     Access automatically expires after the set time period
//                   </MDTypography>
//                 </MDBox>
//               </MDBox>
              
//               <MDBox>
//                 <MDTypography variant="subtitle2" fontWeight="medium" gutterBottom>
//                   Security Measures
//                 </MDTypography>
//                 <MDBox display="flex" alignItems="center" mb={1}>
//                   <VerifiedUser sx={{ mr: 1, fontSize: '1rem', color: 'success.main' }} />
//                   <MDTypography variant="body2" color="text.secondary">
//                     All access is logged and audited
//                   </MDTypography>
//                 </MDBox>
//                 <MDBox display="flex" alignItems="center" mb={1}>
//                   <VerifiedUser sx={{ mr: 1, fontSize: '1rem', color: 'success.main' }} />
//                   <MDTypography variant="body2" color="text.secondary">
//                     Access is time-limited and can be revoked anytime
//                   </MDTypography>
//                 </MDBox>
//                 <MDBox display="flex" alignItems="center">
//                   <VerifiedUser sx={{ mr: 1, fontSize: '1rem', color: 'success.main' }} />
//                   <MDTypography variant="body2" color="text.secondary">
//                     Support actions are tracked and recorded
//                   </MDTypography>
//                 </MDBox>
//               </MDBox>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Confirmation Modal */}
//       <Dialog
//         open={isConfirmationModalOpen}
//         onClose={closeConfirmationModal}
//         aria-labelledby="support-access-dialog-title"
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle id="support-access-dialog-title">
//           Confirm Support Access
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             You are about to grant our support team access to your account for <strong>{accessDuration} hours</strong>. 
//             During this time, support staff will be able to access your account to help troubleshoot issues.
//           </DialogContentText>
//           <MDBox mt={2}>
//             <Alert severity="info">
//               You can revoke this access at any time from the Support Access settings.
//             </Alert>
//           </MDBox>
//         </DialogContent>
//         <DialogActions>
//           <MDButton onClick={closeConfirmationModal} color="secondary">
//             Cancel
//           </MDButton>
//           <MDButton onClick={handleGrantAccess} color="info" variant="contained">
//             Grant Access
//           </MDButton>
//         </DialogActions>
//       </Dialog>
//     </MDBox>
//   );
// };

// export default SupportSettings;




import React, { useState, useEffect } from 'react';
import { 
  Box,
  Card,
  CardContent,
  Typography,
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  useMediaQuery,
  useTheme,
  SvgIcon
} from '@mui/material';
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { 
  Security, 
  Warning 
} from '@mui/icons-material';
import { useAuth } from 'auth/Auth';

// Inline SVG Component for Support Illustration
const SupportIllustration = (props) => (
  <SvgIcon 
    {...props} 
    viewBox="0 0 500 300"
    sx={{ 
      width: '100%', 
      height: 'auto', 
      maxHeight: 180,
      ...props.sx 
    }}
  >
    <defs>
      <linearGradient id="supportGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{stopColor:'#6a11cb', stopOpacity:1}} />
        <stop offset="100%" style={{stopColor:'#2575fc', stopOpacity:1}} />
      </linearGradient>
    </defs>
    
    {/* Support Person */}
    <circle cx="250" cy="120" r="70" fill="url(#supportGradient)" opacity="0.3" />
    
    {/* Animated Headset */}
    <g transform="translate(250, 120)">
      <g 
        style={{
          transformOrigin: 'center',
          animation: 'headsetRotate 2s infinite alternate'
        }}
      >
        <path 
          d="M-40,0 Q-55,-25 -40,-50 Q-25,-75 0,-75 Q25,-75 40,-50 Q55,-25 40,0" 
          fill="none" 
          stroke="#2575fc" 
          strokeWidth="8"
        />
        <circle cx="-40" cy="0" r="12" fill="#6a11cb" />
        <circle cx="40" cy="0" r="12" fill="#6a11cb" />
      </g>
    </g>
    
    {/* Support Icons */}
    <g transform="translate(250, 220)">
      <g 
        style={{
          animation: 'iconFloat 1s infinite alternate'
        }}
      >
        <path 
          d="M-40,-15 L-24,-30 L-8,-15 L8,-30 L24,-15" 
          fill="none" 
          stroke="#2575fc" 
          strokeWidth="4"
        />
        <circle cx="-32" cy="-22" r="8" fill="#6a11cb" opacity="0.6" />
        <circle cx="0" cy="-22" r="8" fill="#6a11cb" opacity="0.6" />
        <circle cx="32" cy="-22" r="8" fill="#6a11cb" opacity="0.6" />
      </g>
    </g>
    
    <style>
      {`
        @keyframes headsetRotate {
          from { transform: rotate(-5deg); }
          to { transform: rotate(5deg); }
        }
        @keyframes iconFloat {
          from { transform: translateY(-5px); }
          to { transform: translateY(5px); }
        }
      `}
    </style>
  </SvgIcon>
);

const SupportSettings = () => {
  const { axiosInstance } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [isAccessGranted, setIsAccessGranted] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Snackbar state
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // Check initial support access status on component mount
  useEffect(() => {
    checkSupportAccessStatus();
  }, []);

  const checkSupportAccessStatus = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get('/support-access/status');
      setIsAccessGranted(response.data.isActive);
    } catch (error) {
      console.error('Error checking support access status:', error);
      setError('Failed to check support access status');
      showSnackbar('Failed to check support access status', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleGrantAccess = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      // API call to grant support access
      await axiosInstance.get('/support-access/');
      
      setIsAccessGranted(true);
      setIsConfirmationModalOpen(false);
      showSnackbar('Support access granted successfully');
    } catch (error) {
      console.error('Error granting support access:', error);
      const errorMessage = error.response?.data?.detail || 'Failed to grant support access';
      setError(errorMessage);
      showSnackbar(errorMessage, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleRevokeAccess = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      // API call to revoke support access
      await axiosInstance.get('/support-access/');
      
      setIsAccessGranted(false);
      showSnackbar('Support access revoked successfully');
    } catch (error) {
      console.error('Error revoking support access:', error);
      const errorMessage = error.response?.data?.detail || 'Failed to revoke support access';
      setError(errorMessage);
      showSnackbar(errorMessage, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };

  return (
    <MDBox 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        p: 2
      }}
    >
      <Card 
        sx={{ 
          maxWidth: 450,
          width: '100%',
          boxShadow: '0 6px 20px 0 rgba(0,0,0,0.08)',
          borderRadius: 2
        }}
      >
        <CardContent sx={{ p: 2 }}>
          {/* Animated Illustration */}
          <MDBox 
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 2,
              opacity: 0.8
            }}
          >
            <SupportIllustration />
          </MDBox>

          <MDTypography 
            variant="h5" 
            textAlign="center" 
            color="primary" 
            mb={1}
          >
            Support Access Control
          </MDTypography>

          <MDTypography 
            variant="body2" 
            color="text.secondary" 
            textAlign="center" 
            mb={3}
          >
            Temporarily grant our support team access to help troubleshoot your account.
          </MDTypography>

          {isAccessGranted ? (
            <MDBox 
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2
              }}
            >
              <Alert 
                severity="info" 
                variant="outlined"
                sx={{ 
                  width: '100%',
                  justifyContent: 'center'
                }}
              >
                Support access is currently active
              </Alert>
              
              <MDButton 
                color="error" 
                variant="contained"
                onClick={handleRevokeAccess}
                disabled={isLoading}
                startIcon={<Warning />}
                sx={{ minWidth: 180 }}
              >
                {isLoading ? 'Processing...' : 'Revoke Access'}
              </MDButton>
            </MDBox>
          ) : (
            <MDBox 
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2
              }}
            >
              <MDButton 
                color="primary" 
                variant="contained"
                onClick={openConfirmationModal}
                disabled={isLoading}
                startIcon={<Security />}
                sx={{ 
                  minWidth: 180,
                  py: 1
                }}
              >
                {isLoading ? 'Processing...' : 'Grant Support Access'}
              </MDButton>
            </MDBox>
          )}
        </CardContent>
      </Card>

      {/* Confirmation Modal */}
      <Dialog
        open={isConfirmationModalOpen}
        onClose={closeConfirmationModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Support Access</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to grant support access? 
            Our team will be able to help diagnose account issues.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton 
            onClick={closeConfirmationModal} 
            color="secondary"
            size="small"
          >
            Cancel
          </MDButton>
          <MDButton 
            onClick={handleGrantAccess} 
            color="primary" 
            variant="contained"
            size="small"
          >
            Confirm
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </MDBox>
  );
};

export default SupportSettings;